import { Component, OnInit } from "@angular/core";
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { AuthService } from "./auth/auth.service";
import { ScreenSizeService } from "./services/screen-size.service";
import { SidebarService } from "./services/sidebar.service";
import { MOesWorkspaceService } from "./modules/mobile/services/m-oes-workspace.service";
import { MasterCustomerService } from "./views/oes/services/master-customer.service";
import { Subscription } from "rxjs/Subscription";

@Component({
  // tslint:disable-next-line
  selector: "body",
  styleUrls: ["./app.component.scss"],
  templateUrl: "app.component.html",
  providers: [SidebarService, MasterCustomerService],
})
export class AppComponent implements OnInit {
  private screenSizeService: ScreenSizeService;
  private mobileWorkspaceService: MOesWorkspaceService;

  private whatsNewVisible = false;
  subscription: Subscription;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public auth: AuthService,
    private sidebarService: SidebarService,
    private masterCustomerService: MasterCustomerService
  ) {}

  ngOnInit() {
    this.screenSizeService = ScreenSizeService.getInstance();
    const isMobileScreen =
      window.screen.width <= ScreenSizeService.MOBILE_SCREEN_WIDTH;
    if (isMobileScreen) {
      this.screenSizeService.setMobileLayout();
    } else {
      this.screenSizeService.setDesktopLayout();
    }

    this.mobileWorkspaceService = MOesWorkspaceService.getInstance();
    if (this.auth.isAuthenticated) {
      this.masterCustomerService
        .getById(this.auth.workspaceMasterCustomerID)
        .subscribe((result) => {
          if (result.success) {
            const allowInventoryManagement =
              Number(result.data.CU0_ALLOW_INVENTORY_MANAGEMENT) === 1;
            this.mobileWorkspaceService.setInventoryManagement(
              allowInventoryManagement
            );
          }
        });
    }

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
    });

    this.router.events
      .filter((event) => event instanceof NavigationEnd)
      .subscribe((event) => {
        let currentRoute = this.route.root;
        do {
          const childrenRoutes = currentRoute.children;
          currentRoute = null;
          childrenRoutes.forEach((route) => {
            if (route.outlet === "primary") {
              const routeSnapshot = route.snapshot;
              if (routeSnapshot.url.length == 0) {
                this.router.navigateByUrl("dashboard");
              }
              currentRoute = route;
            }
          });
        } while (currentRoute);
      });

    this.subscription = this.sidebarService
      .getWhatsNewStatus()
      .subscribe((value: boolean) => {
        this.whatsNewVisible = value;
      });
  }

  hideOverlay() {
    this.sidebarService.setStatus(false);
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/app.component.ts